import { Box, Grid, Paper, Typography } from "@mui/material";
import { COLORS } from "assets";
import useTranslation from "hooks/useTranslation";

function PlaceholderCard({ height, label }: { height: number; label?: string }) {
  return (
    <Paper
      elevation={0}
      sx={{
        height,
        bgcolor: COLORS.surface.card,
        borderRadius: `${COLORS.radius.lg}px`,
        boxShadow: COLORS.shadow.card,
        border: `1px solid ${COLORS.surface.border}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2
      }}
    >
      {label ? (
        <Typography sx={{ color: COLORS.surface.secondaryText, fontSize: 13, textAlign: "center" }}>
          {label}
        </Typography>
      ) : null}
    </Paper>
  );
}

/** Layout of count + chart cards with no data (unlock gate or no models). */
export default function EmptyDashboardShell({ message }: { message?: string }) {
  const t = useTranslation();
  const waiting =
    message ||
    t["Dashboard waiting for site"] ||
    "Charts appear after you unlock and select a site.";

  return (
    <Box aria-hidden>
      <Box
        display="flex"
        flexWrap="wrap"
        gap={2}
        mb={2}
        sx={{
          "& > *": {
            flex: { xs: "1 1 100%", sm: "1 1 calc(50% - 8px)", md: "1 1 calc(33.333% - 11px)" },
            minWidth: 0
          }
        }}
      >
        {[0, 1, 2].map((key) => (
          <Box key={key}>
            <PlaceholderCard height={112} />
          </Box>
        ))}
      </Box>
      <Grid container spacing={2} mb={2}>
        <Grid item xs={12} md={6}>
          <PlaceholderCard height={280} label={waiting} />
        </Grid>
        <Grid item xs={12} md={6}>
          <PlaceholderCard height={280} label={waiting} />
        </Grid>
      </Grid>
    </Box>
  );
}
